<div class="detail-action-bar"
     [class.align-start]="align === 'start' && !hasSplit"
     [class.align-center]="align === 'center' && !hasSplit"
     [class.align-end]="align === 'end' && !hasSplit"
     [class.align-split]="hasSplit"
     [attr.data-testid]="testId || null">

    <ng-container *ngIf="hasSplit; else simpleRow">
        <div class="action-group action-group--start">
            <app-detail-action-button *ngFor="let a of leftActions"
                                      [action]="a"
                                      [flavor]="flavor"
                                      (clicked)="onClick($event)">
            </app-detail-action-button>
            <app-detail-action-button *ngFor="let a of unalignedLeftActions"
                                      [action]="a"
                                      [flavor]="flavor"
                                      (clicked)="onClick($event)">
            </app-detail-action-button>
        </div>
        <div class="action-group action-group--end">
            <app-detail-action-button *ngFor="let a of rightActions"
                                      [action]="a"
                                      [flavor]="flavor"
                                      (clicked)="onClick($event)">
            </app-detail-action-button>
        </div>
    </ng-container>

    <ng-template #simpleRow>
        <app-detail-action-button *ngFor="let a of actions"
                                  [action]="a"
                                  [flavor]="flavor"
                                  (clicked)="onClick($event)">
        </app-detail-action-button>
    </ng-template>
</div>
